import { toTimestamp, type EpgDateEx } from '$/epg/dates'
import { type EpgDateExStamped } from './index.h'

/**
 * Add timestamp to dates,
 * because `coveredDays` property in `ProgramList` requires it as `stamp` property
 */
export const toStamped = (date: EpgDateEx): EpgDateExStamped => ({
  ...date,
  stamp: toTimestamp(date),
})
